<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="8">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="projectsTable.additionalFilters"
                                    :default-sort="projectsTable.defaultSort"
                                    :excel="true"
                                    :fields="projectsTable.headers"
                                    :header-selection-key="'projects-headers'"
                                    :height="projectsTable.height"
                                    :total-records="projectsTable.total"
                                    :filter-save-key="'projects-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in projectsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('name')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('user_display')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.user_display }}
                                        </td>
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('date_created_display')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.date_created_display }}
                                        </td>
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('deadline_display')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.deadline_display }}
                                        </td>
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('amount_display')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.amount_display }}
                                        </td>
                                        <td
                                            v-if="projectsTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Projects',
    components: {TheTable},
    data: function () {
        return {
            projectsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.name'), value: 'name', type: '', allowFilter: true},
                    {text: this.$t('fields.user'), value: 'user_display', type: '', allowFilter: true},
                    {text: this.$t('fields.dateCreated'), value: 'date_created_display', type: '', allowFilter: true},
                    {text: this.$t('fields.deadline'), value: 'deadline_display', type: '', allowFilter: true},
                    {text: this.$t('fields.amount'), value: 'amount_display', type: '', allowFilter: true},
                    {text: this.$t('fields.active'), value: 'active', type: '', width: '100px', allowFilter: true},
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [
                    {text: this.$t('fields.name'), value: 'name', type: 'string'},
                    {text: this.$t('fields.user'), value: 'user', type: 'dropdown|users'},
                    {text: this.$t('fields.dateCreated'), value: 'date_created', type: 'date_range'},
                    {text: this.$t('fields.deadline'), value: 'deadline', type: 'date_range'},
                    {text: this.$t('fields.amount'), value: 'amount', type: 'price_range'},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: true,
                        defaultDisplay: this.$t('labels.yes'),
                    },
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/projects/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/projects/' + id);
            } else {
                let routeData = this.$router.resolve('/projects/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.projectsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'projects',
                request,
                (data, success) => {
                    if (success) {
                        vm.projectsTable.items = data.items;
                        vm.projectsTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'projects',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/projects', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.projectsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.projects'), href: '/#/projects', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
